module.exports = __webpack_public_path__ + "files/75ca74f2d5ae2c5552b7100b4d75c8da.png";